module.exports = __webpack_public_path__ + "static/media/apti_news_roi.507a7182.jpg";